import React, { useEffect, useState, useRef } from "react";
//i18n
import { withNamespaces } from "react-i18next";

import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Button,
  CardTitle,
  Label,
  CardSubtitle,
  Container,
  Spinner,

} from "reactstrap";

import {
  AvForm,
  AvField,
} from "availity-reactstrap-validation";
// Redux
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

//Import Breadcrumb

import Breadcrumb_2Items from "../../../../components/Common/Breadcrumb_2Items";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";

import showNotification from "../../../../helpers/show_notification";

import { postSubmitForm } from "../../../../helpers/forms_helper";

import Select from "react-select";
import makeAnimated from "react-select/animated";
import { convertToLowestUnit, formatUnitsForReport, GetUpdatedDelivered,  } from "../../../../helpers/units";
import preloader from "../../../../helpers/preloader";
import EnterQuantityModal from "../../../../components/EnterQuantityModal";
const animatedComponents = makeAnimated();

const ItemAddOrder = (props) => {
  const role = localStorage.getItem("role")
  const storeName = role ==="Storekeeper" ? "Central Kitchen Store" : localStorage.getItem("store_name")
  const refForForm = useRef(null);
  const refSelectItem = useRef(null);
  useEffect(() => {
    loadAllItems();
  }, []);
 
  const [remarks, setRemarks] = useState();
  const [isUrgent, setIsUrgent] = useState(false)
  const [allItems, setAllItems] = useState([]);
  const [selectedItem, setSelectedItem] = useState();
  const loadAllItems = async () => {
    try {
      let payload = {};
    let url = process.env.REACT_APP_BASEURL + "branchitems/getforbranch";

    preloader(true);
    let response = await postSubmitForm(url, payload);
    if (response.status === 1) {
      let filtered = response.data?.filter((d)=>d.is_active) || []
      preloader(false);
    setAllItems(filtered)
    } else {
      preloader(false);
      showNotification(response.message, "Error");
    }
    } catch (error) {
      showNotification(error,"Error")
      preloader(false)
    }
  };

  const [itemsForOrder, setItemsForOrder] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false)
  const [isDraftSubmitting, setIsDraftSubmitting] = useState(false)
  const handleValidSubmit = async (e, v,is_darft) => {
    try {
      let url = "";
      if(is_darft){
        url = process.env.REACT_APP_BASEURL +  "itemorderdrafts/insert";
        setIsDraftSubmitting(true)
      }else{
        url = process.env.REACT_APP_BASEURL +  "itemorders/insert";
        setIsDisabled(true)
      }
      const object = {
        item_details: itemsForOrder,
        is_urgent: isUrgent,
        remarks: remarks,
      };
      let response = await postSubmitForm(url, object);
      if (response.status === 1) {
        setRemarks();
        setIsUrgent(false)
        setIsDraftSubmitting(false)
        setIsDisabled(false)
        setItemsForOrder([]);
        setSelectedItem();
        loadAllItems();
        refSelectItem.current.select.clearValue();
        refForForm.current.reset();
        showNotification(response.message, "Success");
        refForForm.current.reset();
      } else {
        setIsDisabled(false)
        setIsDraftSubmitting(false)
        showNotification(response.message, "Error");
      }
    } catch (error) {
      setIsDisabled(false)
      setIsDraftSubmitting(false)
      showNotification(error.message, "Error");
    }
  };
  function deleteFormatter(cell, row, rowIndex, extraData) {
    return (
      <>
        <span className="text-danger">
          <i
            className="bx bxs-trash font-size-15"
            title="Click to Delete"
            style={{ cursor: "pointer" }}
            onClick={() => {
              let arr = extraData.filter(
                (item) => item.item_id !== row.item_id
              );

              setItemsForOrder(arr);
            }}
          ></i>
        </span>
      </>
    );
  }
  const columns = [
    {
      dataField: "category",
      text: props.t("Category"),
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      dataField: "sub_category",
      text: props.t("Sub-Category"),
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      dataField: "name",
      text: props.t("Name"),
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      sort: true,
    },
    {
      text: props.t("Available"),
      dataField: "available",
      sort: false,
      editable: false,
      formatter: (cell, row) => {
        return formatUnitsForReport(row.available,row.unit_levels)             
      },
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      footer: false,
    },
    {
      text: props.t("Quantity"),
      dataField: "arrangement_quantity",
      sort: false,
      editable: false,
      formatter: (cell, row) => {
        return formatUnitsForReport(row.arrangement_quantity)             
      },
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      footer: false,
    },
    // {
    //   text: props.t("Quantity"),
    //   dataField: "quantity",
    //   sort: false,
    //   editable: false,
    //   formatter: (cell, row) => {
    //     return formatUnitsForReport(row.quantity)             
    //   },
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "15%" };
    //   },
    //   footer: false,
    // },
    {
      text: props.t("Remove"),
      formatter: deleteFormatter,
      formatExtraData: itemsForOrder,
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
  ];
  const [selectedRowsUnit, setSelectedRowsUnit] = useState([]);
  const [selectUnitModal, setSelectUnitModal] = useState(false);

  function handleCloseModal() {
    setSelectUnitModal(false);
    setSelectedRowsUnit([])
  }

  // const handleAddQuantity = async (quantity) => {
  //     let maxLimit = convertToLowestUnit(selectedItem.unit_levels,[{unit:selectedItem.unit_for_max_order,value:selectedItem.max_order_limit}]);
  //     let totalEntered =   convertToLowestUnit(selectedItem.unit_levels,quantity)
  //     if(totalEntered>maxLimit){
  //       showNotification(`can not add more than <strong> ${selectedItem.max_order_limit+" "+selectedItem.unit_for_max_order} </strong>`,"Warning")
  //       return
  //     }
  //  let convertedQuantity = GetUpdatedDelivered(quantity,selectedItem.unit_levels)
  //   var new_array_items = JSON.parse(JSON.stringify(itemsForOrder));
  //   const existing_item = new_array_items.filter(function (item) {
  //     return item.item_id === selectedItem.item_id;
  //   });

  //   if (existing_item.length > 0) {
  //     showNotification(
  //       props.t("This item is already added."),
  //       props.t("Error")
  //     );
  //   } else if (selectedItem) {
  //     let item_to_add = {};
  //     item_to_add.item_id = selectedItem?.item_id;
  //     item_to_add.name = selectedItem.name;
  //     item_to_add.category = selectedItem.category;
  //     item_to_add.sub_category = selectedItem.sub_category;
  //     item_to_add.brand = selectedItem.brand;
  //     item_to_add.available = selectedItem.available.map(({ unit, value }) => ({ unit, value: parseFloat(value) })) || null;
  //     item_to_add.quantity = convertedQuantity.map(({ unit, value }) => ({ unit, value: parseFloat(value) })) || null;
  //     item_to_add.unit_levels = selectedItem.unit_levels;
  //     item_to_add.unit_for_po = selectedItem.unit_for_po;
  //     item_to_add.direct_po = selectedItem.direct_po;
  //     item_to_add.unit_for_max_order = selectedItem.unit_for_max_order;
  //     item_to_add.expiry_date = selectedItem.expiry_date;
  //     if(selectedItem.max_order_limit>0){
  //       item_to_add.max_order_limit = selectedItem.max_order_limit;
  //     }
  //     item_to_add.cost_price = selectedItem.cost_price;
  //     item_to_add.selling_price = selectedItem.selling_price;
  //     setItemsForOrder([...itemsForOrder, item_to_add]);
  //     setSelectUnitModal(false);
  //     setSelectedItem();
  //     setSelectedRowsUnit([]);
  //     refSelectItem.current.select.clearValue();
  //   } else {
  //     showNotification(props.t("Select a item batch first."), props.t("Error"));
  //   }
  // };

   function handleAddQuantity(e,v) {
    e.preventDefault()
    let arrangement_quantity = [{unit:selectedItem.unit_for_max_order, value:Number(v.arrangement_quantity)}]
      let maxLimit = convertToLowestUnit(selectedItem.unit_levels,[{unit:selectedItem.unit_for_max_order,value:selectedItem.max_order_limit}]);
      let totalEntered =   convertToLowestUnit(selectedItem.unit_levels,arrangement_quantity)
      if(totalEntered>maxLimit){
        showNotification(`can not add more than <strong> ${selectedItem.max_order_limit+" "+selectedItem.unit_for_max_order} </strong>`,"Warning")
        return
      }
   let convertedQuantity = GetUpdatedDelivered(arrangement_quantity,selectedItem.unit_levels)
    var new_array_items = JSON.parse(JSON.stringify(itemsForOrder));
    const existing_item = new_array_items.filter(function (item) {
      return item.item_id === selectedItem.item_id;
    });

    if (existing_item.length > 0) {
      showNotification(
        props.t("This item is already added."),
        props.t("Error")
      );
    } else if (selectedItem) {
      let item_to_add = {};
      item_to_add.item_id = selectedItem?.item_id;
      item_to_add.name = selectedItem.name;
      item_to_add.category = selectedItem.category;
      item_to_add.sub_category = selectedItem.sub_category;
      item_to_add.arrangement_quantity = arrangement_quantity;
      item_to_add.available = selectedItem.available.map(({ unit, value }) => ({ unit, value: parseFloat(value) })) || null;
      item_to_add.quantity = convertedQuantity.map(({ unit, value }) => ({ unit, value: parseFloat(value) })) || null;
      item_to_add.initial_order_quantity = convertedQuantity.map(({ unit, value }) => ({ unit, value: parseFloat(value) })) || null;
      item_to_add.unit_levels = selectedItem.unit_levels;
      item_to_add.unit_for_po = selectedItem.unit_for_po;
      item_to_add.direct_po = selectedItem.direct_po;
      item_to_add.unit_for_max_order = selectedItem.unit_for_max_order;
      item_to_add.expiry_date = selectedItem.expiry_date;
      if(selectedItem.max_order_limit>0){
        item_to_add.max_order_limit = selectedItem.max_order_limit;
      }
      item_to_add.cost_price = selectedItem.cost_price;
      item_to_add.selling_price = selectedItem.selling_price;
      setItemsForOrder([...itemsForOrder, item_to_add]);
      setSelectUnitModal(false);
      setSelectedItem();
      setSelectedRowsUnit([]);
      refSelectItem.current.select.clearValue();
    } else {
      showNotification(props.t("Select a item batch first."), props.t("Error"));
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            alternateTitle={props.t("Items")}
            title={props.t("Orders")}
            breadcrumbItem1={props.t("Items")}
            breadcrumbItem2={props.t("Add Order")}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm
                    // onValidSubmit={()=>setSelectUnitModal(!selectUnitModal)}
                    onValidSubmit={handleAddQuantity}
                    ref={refForForm}
                  >
                    <CardTitle>{props.t("Add New Order")}</CardTitle>
                    <CardSubtitle className="mb-3">
                      {props.t(
                        "Enter the following details to place order for items"
                      )}
                    </CardSubtitle>
                    <Row>
                      <Col lg={3} md={3}>
                        <Label>{props.t("Item")}</Label>
                        <Select
                          ref={refSelectItem}
                          value={selectedItem}
                          onChange={(selected) => {
                            setSelectedItem(selected);
                          }}
                          options={allItems}
                          classNamePrefix="select2-selection"
                          components={animatedComponents}
                          required
                        />
                      </Col>
                      {selectedItem && (
            <>
              <Col lg={3} md={4} >
                <br />
                <p><Label>Central Store Avl.</Label> -&nbsp;
                {formatUnitsForReport(selectedItem.central_store_available,selectedItem?.unit_levels)}
                 <hr style={{marginBottom:"5px",marginTop:"-5px"}} />
                <Label>{storeName} Avl. -&nbsp; </Label> 
                {formatUnitsForReport(selectedItem.available,selectedItem?.unit_levels)}
                  </p>
              </Col>
              {/* <Col lg={2} md={2}>
                <br />
                <Label>{storeName} Avl. </Label>
                <br />
                <Label>
                  {formatUnitsForReport(selectedItem.available,selectedItem?.unit_levels)}
                </Label>
              </Col> */}
              <Col lg={2} md={2}>
                <br />
                <Label>Threshold Quantity</Label>
                <br />
                <Label>
                  {selectedItem.threshold +
                    " " +
                    selectedItem.unit_for_threshold}
                </Label>
              </Col>
              <Col lg={2} md={2}>
                              <Label>
                                {props.t("Qty.")} in {`${selectedItem.unit_for_max_order}`}
                              </Label>

                              <AvField
                                name="arrangement_quantity"
                                placeholder={props.t("Enter Quantity")}
                                type="number"
                                min="0"
                                step="1"
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage: "Quantity cannot be empty.",
                                  },
                                  pattern: {
                                    value: "^[0-9]+$",
                                    errorMessage: props.t(
                                      "Only numbers are allowed."
                                    ),
                                  },
                                  max: {
                                    value:selectedItem && selectedItem.max_order_limit,
                                    errorMessage: selectedItem &&
                                      props.t("Cannot enter more than ") +
                                      selectedItem.max_order_limit +" " +selectedItem.unit_for_max_order +".",
                                  },
                                  min: {
                                    value:1,
                                    errorMessage: props.t("Minimum 1 is required"),
                                  },
                                }}
                              />
                            </Col>
            </>
          )}
          
                      <Col lg={1} md={1} className="mb-4">
                        <Label>&nbsp;</Label>
                        <br />
                        <Button
                          type="submit"
                          color="primary"
                          className="btn btn-info waves-effect waves-light btn-sm"
                        >
                          <i class="bx bx-add-to-queue"></i> {props.t("Add")}
                        </Button>
                      </Col>
                
                  
                    </Row>
                    {/* <Button type="submit">Submit</Button> */}
                  </AvForm>
                  <hr />
                  {itemsForOrder && itemsForOrder.length > 0 && (
                    <>
                      <BootstrapTable
                        bootstrap4
                        keyField="_id"
                        data={itemsForOrder && itemsForOrder}
                        columns={columns}
                        noDataIndication="No data to display."
                        striped
                        hover
                        condensed
                      />
                      <AvForm>
                        <Row>
                          <Col lg={6}>
                            <AvField
                              name="remarks"
                              value={remarks}
                              onChange={(e) => {
                                setRemarks(e.target.value);
                              }}
                              label={props.t("Remarks")}
                              placeholder={props.t("Enter Remarks")}
                              type="textarea"
                            />
                          </Col>
                          <Col lg={12}>
                            <div class="form-check">
                              <input
                                type="checkbox"
                                name="is_urgent"
                                id="isUrgentCheckbox"
                                className="is-untouched is-pristine av-valid form-check-input"
                                checked={isUrgent}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setIsUrgent(true);
                                  } else {
                                    setIsUrgent(false);
                                  }
                                }}
                              />
                              <label for="isUrgentCheckbox">
                                {props.t("This is an urgent order.")}
                              </label>
                            </div>
                          </Col>
                          <Col lg={12}>
                            <hr />
                            <FormGroup className="mb-0 text-left">
                              <div>
                                <Button
                                  type="submit"
                                  color="primary"
                                  style={{width:"150px"}}
                                  disabled={isDisabled || isDraftSubmitting}
                                  onClick={(e,v)=>handleValidSubmit(e,v,false)}
                                  className="mr-3"
                                >
                          {isDisabled ? <Spinner size="sm" /> : props.t("Place Order")} 
                                </Button>
                                <Button
                                  type="submit"
                                  color="secondary"
                                  onClick={(e,v)=>handleValidSubmit(e,v,true)}
                                  style={{width:"180px"}}
                                  disabled={isDraftSubmitting || isDisabled}
                                >
                          {isDraftSubmitting ? <Spinner size="sm" /> : props.t("Save as Draft")} 
                                </Button>
                              </div>
                            </FormGroup>
                          </Col>
                        </Row>
                      </AvForm>
                    </>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        {/* Add Quantity Modal  */}

      <EnterQuantityModal
            isOpen={selectUnitModal}
            toggle={handleCloseModal}
            onSubmit={handleAddQuantity}
            item={selectedItem}
            checkLimitFor={"order"}
            // selectedBatch={selectedBatch}
          />
      </div>
    </React.Fragment>
  );
};
export default withRouter(connect(null, {})(withNamespaces()(ItemAddOrder)));
